import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import FloatButton from './ui/FloatButton'

const GenerateReport = () => {

  const navigate = useNavigate()

  const onGenerateReportClick = useCallback(() => navigate('/report'), []) 
  
  return (
    <FloatButton handleClick={onGenerateReportClick} width='200px' margin='1rem'><h2 style={{ textAlign: "center" }}>Generate Report</h2></FloatButton>
  )
}

export default GenerateReport